var map = {
	"./angel/celestial/dream-sleep.png": 1857,
	"./default.png": 929,
	"./demon/soul-master/malediction.png": 1858,
	"./dragonborn/sky-predator/dragon-feast.png": 1859,
	"./elf/forest-ghost/agility-aura.png": 1860,
	"./elf/forest-ghost/dazzle-slash.png": 1861,
	"./elf/forest-ghost/phantom-strike.png": 1862,
	"./elf/nature-keeper/even-swiftness.png": 1863,
	"./elf/nature-keeper/latent-venom-arrow.png": 1864,
	"./elf/nature-keeper/tanglevine.png": 1865,
	"./elf/wind-hunter/swift-step.png": 1866,
	"./elf/wind-hunter/swiftness-aura.png": 1867,
	"./elf/wind-hunter/teardown-arrow.png": 1868,
	"./fairy/enchantress/arcane-transmit.png": 1869,
	"./fairy/enchantress/seed-of-healing-enhance.png": 1870,
	"./fairy/enchantress/seed-of-healing.png": 1871,
	"./fairy/outlaw-wanderer/doppelganger.png": 1872,
	"./fairy/outlaw-wanderer/outlaw-evasion.png": 1873,
	"./fairy/outlaw-wanderer/outlaw-reflexes.png": 1874,
	"./fairy/thaumaturge/shadow-realm.png": 1875,
	"./fairy/thaumaturge/shadow-words-corruption.png": 1876,
	"./fairy/thaumaturge/shadow-words.png": 1877,
	"./human/blade-dancer/evasion.png": 1878,
	"./human/blade-dancer/fury-strike.png": 1879,
	"./human/blade-dancer/shadow-walk.png": 1880,
	"./human/paladin/heroic-charge.png": 1881,
	"./human/paladin/holy-defiance-aura.png": 1882,
	"./human/paladin/holy-judgement.png": 1883,
	"./human/spell-singer/magic-ball.png": 1884,
	"./human/spell-singer/time-warp.png": 1885,
	"./human/spell-singer/wisdom-aura.png": 1886,
	"./orc/berserker/brutal-strength.png": 1887,
	"./orc/berserker/deaths-fury.png": 1888,
	"./orc/berserker/provoke.png": 1889,
	"./orc/warlord-shaman/arcanum-totem.png": 1890,
	"./orc/warlord-shaman/chain-of-wounds.png": 1891,
	"./orc/warlord-shaman/flame-shield.png": 1892,
	"./orc/warrior/glory-stance.png": 1893,
	"./orc/warrior/skull-bash.png": 1894,
	"./orc/warrior/war-shout.png": 1895
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1856;